import React from "react";
import { Box, Button, Flex, Icon, Text } from "@chakra-ui/react";
import { FaFileExport, FaPlay } from "react-icons/fa";
import FinantialList from "./components/financialList";
import SimplifiedDetails from "./components/simplifiedDetails";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../atoms/customColors";

export default function Financeiro() {
  const colors = useRecoilState(customColors)[0];

  return (
    <Flex
      direction={"column"}
      alignItems={"center"}
      bgColor={"#F5F5F5"}
      h="100%"
      w={"99.8%"}
    >
      <Box mb={"10px"} width={"100%"} height={"fit-content"} mx="auto" px={3}>
        <Flex px={8} alignItems="center">
          <FaPlay color={colors.BLUEMONEDDBUTTONS} size="25px" />
          <Text
            mx={4}
            mt={4}
            color={colors.BLUEMONEDDBUTTONS}
            fontSize={35}
            fontWeight={"bold"}
          >
            Extrato
          </Text>
        </Flex>
      </Box>

      <Flex w={"99.5%"} h={"95%"}>
        <SimplifiedDetails />
      </Flex>
    </Flex>
  );
}
